import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from './ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const scrollToCta = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0f1923]/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-137">
      <div className="container mx-auto px-6 flex items-center justify-between max-w-6xl" data-id="element-138">
        <div className="flex items-center gap-2" data-id="element-139">
          <span className={`font-serif font-bold text-xl tracking-wide ${isScrolled ? 'text-[#c9a84c]' : 'text-[#f0ebe3]'}`} data-id="element-140">
            Plan Anti-Pantalla
          </span>
        </div>

        <Button variant="primary" className="!px-5 !py-2 !text-sm" onClick={() => document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-141">
          Quiero el Plan
        </Button>
      </div>
    </motion.nav>;
}